import { render, staticRenderFns } from "./AddEducationModal.vue?vue&type=template&id=ab60f64a&scoped=true&"
import script from "./AddEducationModal.vue?vue&type=script&lang=js&"
export * from "./AddEducationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab60f64a",
  null
  
)

export default component.exports